import { useQuery } from "react-query"
import Select from "react-select"
import axios from "axios"
import cn from "classnames"
import customStyles from "./styles"

const fetchFuelTypes = async () => {
  const { data } = await axios.get<any>("products/fuel-types")

  const output = data.map((fuelType: any) => ({
    value: fuelType.value,
    label: fuelType.key,
  }))

  return output
}

const FuelTypePicker = (props: {
  selected?: number
  isClearable?: boolean
  flush?: boolean
  className?: string
  placeholder?: string
  label?: string
  onSelect?: (item: any) => void
}) => {
  const { data, isLoading } = useQuery("fuel_types", fetchFuelTypes)
  // if (isLoading) return null

  return (
    <div className={cn("flex-c-box", props.className)}>
      {!props.label ? null : (
        <>
          <span style={{ color: "#486f88", fontWeight: "bold" }}>
            {props.label}
          </span>
          <div style={{ marginTop: 4 }} />
        </>
      )}

      <Select
        isDisabled={isLoading}
        isLoading={isLoading}
        isClearable={props.isClearable}
        placeholder={props.placeholder ?? "Choose Product Type"}
        options={data}
        onChange={props.onSelect}
        styles={customStyles()}
        defaultValue={data?.find((item: any) => item.value === props.selected)}
      />
    </div>
  )
}

export default FuelTypePicker
